import React, {Component} from 'react';

import {Input} from 'reactstrap';

export default class Checkbox extends Component {
    state = {
        checked: !!this.props.defaultChecked
    };

    onChange = () => {
        this.props.onChange && this.props.onChange(!this.state.checked);
        this.setState({checked: !this.state.checked});
    };

    render() {

        const {defaultChecked, label, state} = this.props;

        return (
            <Input type="checkbox" aria-label={label} state={state} onChange={this.onChange} defaultChecked={defaultChecked}/>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/controls/inputs/Checkbox.js